import _ from 'lodash'
import Vue from 'vue';

export default {
    CHANGE_MAIN_MENU(state, mainMenu) {
        state.mainMenu = mainMenu;
    },
    CHANGE_MENU_HIDE(state, menuHide) {
        state.menuHide = menuHide;
    },
    INIT_MENUS(state, menus) {
        state.menus = menus;
    },
    INIT_MENU_GROUPS(state, groups) {
        state.menuGroups = groups;
    },
    CHANGE_SUBGROUPS(state, subGroups) {
        state.subGroups = subGroups;
    },
    INIT_LOGIN_USER(state, user) {
        state.loginUser = user;
        if(!state.project && user.project) {
            state.project = user.project;
        }
    },
    INIT_LOGIN_CUSTOMER(state, customer) {
        state.loginCust = customer;
    },
    INIT_LOGIN_TYPE(state, loginType) {
        state.loginType = loginType;
    },
    INIT_CURRENT_PROJECT(state, project) {
        state.project = project;
        let project_id = _.get(project, 'project_id');

        if(project_id) {
            if(localStorage) {
                localStorage.setItem("project_id", project_id)
            }

            if(Vue.prototype.$utils && Vue.prototype.$utils.setProjectId) {
                Vue.prototype.$utils.setProjectId(project_id);
            }
        }
    },
    CHANGE_OPENMENU(state, openMenu) {
        state.openMenu = openMenu;
    },
    CHANGE_MENUCOLLAPSE(state, menuCollapse) {
        if(typeof menuCollapse === 'undefined') {
            state.menuCollapse = !state.menuCollapse;
        } else {
            state.menuCollapse = menuCollapse;
        }
    },
    DYNC_COMP_LOADED_TAG(state, domain) {
        state.dyncCompLoaded[ domain ] = true;
    },
    CHANGE_PROJECT(state, project) {
        state.project = project;
    },
    INIT_TOKEN(state, token) {
        state.token = token;
    }
}
